/**
 * Menu Badge Helper
 *
 * Handles badge display logic for menu items
 */

import { Badge } from "antd";
import type React from "react";
import { ERoutesPathname } from "@/routers/config";

// Badge configurations for specific menu items
export const MENU_BADGE_CONFIG = {
  [ERoutesPathname.delivery]: {
    storeKey: "deliveryOrdersTotal",
    maxCount: 99,
  },
  // Add other menu item badge configurations here if needed
  // [ERoutesPathname.dispensing]: {
  //   storeKey: 'dispensingTotal',
  //   maxCount: 99,
  // },
} as const;

/**
 * Adding a badge to a menu item
 */
export const addBadgeToMenuLabel = (
  label: React.ReactNode,
  menuKey: string,
  count?: number,
): React.ReactNode => {
  const config = MENU_BADGE_CONFIG[menuKey as keyof typeof MENU_BADGE_CONFIG];

  if (!config || !count || count <= 0) {
    return label;
  }

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex-1 flex justify-between pr-1">
        {label}
        <Badge count={count} size="small" />
      </div>
    </div>
  );
};
